import { memo, useContext } from 'react';
import { Controller } from 'react-hook-form';

import { useLanguage } from 'assets/languages';
import TextInputField from 'components/textInput';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import CampaignFormFieldGroup from '../../../../../campaignFormFieldGroup/campaignFormFieldGroup';
import Select, { SELECT_ON_CHANGE_MODES } from 'components/select';
import { CampaignFormStepThreeContext } from '../../../../campaignFormStepThree.context';

const ReturnManagerFieldGroup = () => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.campaigns };

  const {
    brand,
    campaignFormMethods: { register, control },
  } = useContext(CampaignFormContext);
  const { countryCodeOptions } = useContext(CampaignFormStepThreeContext);

  return (
    <CampaignFormFieldGroup
      wrapperClassName="!gap-10 !pb-0"
      label={languageTexts.create_step3_a_title}
      labelClassName="!text-2xl"
      description={languageTexts.create_step3_a_desc}
      descriptionClassName="!text-sm"
    >
      {/* 담당자명 */}
      <CampaignFormFieldGroup.FormField
        label={
          brand.isWholesale
            ? languageTexts.create_step3_a_wholesale_manager_name
            : languageTexts.create_step3_a_manager_name
        }
        labelClassName="!text-[15px] !font-normal"
      >
        <TextInputField
          bordered
          placeholder={
            brand.isWholesale
              ? languageTexts.create_step3_a_wholesale_manager_name_placeholder
              : languageTexts.create_step3_a_manager_name_placeholder
          }
          register={register('returnManagerName', { required: true })}
        />
      </CampaignFormFieldGroup.FormField>

      {/* 국가 코드 */}
      <CampaignFormFieldGroup.FormField
        label={languageTexts.contact_country_code}
        labelClassName="!text-[15px] !font-normal"
      >
        <Controller
          control={control}
          name="returnManagerCountryCode"
          render={({ field }) => (
            <Select
              bordered
              onChangeMode={SELECT_ON_CHANGE_MODES.VALUE}
              options={countryCodeOptions}
              value={field.value}
              onChange={field.onChange}
            />
          )}
        />
      </CampaignFormFieldGroup.FormField>

      {/* 휴대폰 */}
      <CampaignFormFieldGroup.FormField
        label={
          brand.isWholesale
            ? languageTexts.create_step3_a_wholesale_manager_phone
            : languageTexts.create_step3_a_manager_phone
        }
        labelClassName="!text-[15px] !font-normal"
      >
        <TextInputField
          type="tel"
          numbersOnly
          bordered
          placeholder={languageTexts.create_step3_a_manager_phone_placeholder}
          register={register('returnManagerMobile', { required: true, pattern: /^0[0-9]$/ })}
        />
      </CampaignFormFieldGroup.FormField>

      {/* 반품 받으실 주소 */}
      <CampaignFormFieldGroup.FormField
        label={languageTexts.create_step3_a_return_addr}
        labelClassName="!text-[15px] !font-normal"
      >
        <TextInputField
          bordered
          placeholder={languageTexts.create_step3_a_return_addr_placeholder}
          register={register('returnAddress', { required: true })}
        />
      </CampaignFormFieldGroup.FormField>
    </CampaignFormFieldGroup>
  );
};

export default memo(ReturnManagerFieldGroup);
